import React, { PropTypes } from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import './styles.scss';

import { Modal } from '../../../../shared';

export const ConfirmTimeoff = props => (
  <div className='timeoff-confirm'>
    <ReactCSSTransitionGroup
      component='div'
      className='animationDiv'
      transitionName='slide'
      transitionAppear
      transitionEnter={false}
      transitionLeave={false}
      transitionAppearTimeout={600}
    >
      <Modal
        icontype="fa fa-check-circle fa-4x"
        title={`Thanks ${props.currentUser.name}`}
        message="Your request has been submitted for approval"
        onClick={props.clearUser}
      />
    </ReactCSSTransitionGroup>
  </div>
);


ConfirmTimeoff.propTypes = {
  currentUser: PropTypes.object,
  clearUser: PropTypes.func,
};


export default ConfirmTimeoff;



// WEBPACK FOOTER //
// ./src/components/timeclock/userhub/requests/confirmation/main.jsx